import { Component, OnInit } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { WatchThemeService } from 'src/app/services';
import { DesignBrief } from 'src/app/models';

@Component({
  selector: 'app-watch-theme-brief-modal',
  templateUrl: './watch-theme-brief-modal.component.html',
  styleUrls: ['./watch-theme-brief-modal.component.scss'],
  standalone: false,
})
export class WatchThemeBriefModalComponent implements OnInit {
  title = '';
  formData: any = {};
  brief: DesignBrief | null = null;
  loading = false;

  constructor(
    private watchThemeService: WatchThemeService,
    public modalRef: MdbModalRef<WatchThemeBriefModalComponent>,
  ) {}

  ngOnInit(): void {
    this.brief = this.formData?.brief || null;
    if (this.formData?.themeId) {
      this.loading = true;
      this.watchThemeService.getBrief(this.formData.themeId).subscribe({
        next: (response) => {
          this.brief = { ...this.brief, ...response.data };
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    }
  }

  get isText(): boolean {
    const kind = this.brief?.kind;
    return kind === 'txt' || kind === 'md';
  }

  get isImage(): boolean {
    const kind = this.brief?.kind;
    return kind === 'png' || kind === 'jpg';
  }

  get subtitle(): string {
    if (!this.brief) {
      return '';
    }
    return [this.brief.displayType, this.brief.sizeLabel, this.brief.attachedBy]
      .filter(Boolean)
      .join(' · ');
  }

  close() {
    this.modalRef.close();
  }
}
